import ReactMarkdown from 'react-markdown'
import { Check, Copy } from 'lucide-react'
import { useState } from 'react'

interface AnswerViewProps {
    answer: string
}

export function AnswerView({ answer }: AnswerViewProps) {
    const [copied, setCopied] = useState(false)

    const handleCopy = () => {
        navigator.clipboard.writeText(answer)
        setCopied(true)
        setTimeout(() => setCopied(false), 2000)
    }

    return (
        <div className="p-6 bg-black/40 border border-white/10 rounded-xl relative overflow-hidden group">
            <div className="flex justify-between items-start mb-4">
                <h3 className="text-sm font-medium text-green-400 uppercase tracking-wider">Answer</h3>
                <button
                    onClick={handleCopy}
                    className="p-1.5 hover:bg-white/10 rounded-md transition-colors text-gray-500 hover:text-white"
                    title="Copy to clipboard"
                >
                    {copied ? <Check className="w-4 h-4 text-green-400" /> : <Copy className="w-4 h-4" />}
                </button>
            </div>

            <div className="prose prose-invert max-w-none text-gray-200 leading-relaxed text-sm">
                <ReactMarkdown
                    components={{
                        code: ({ node, inline, className, children, ...props }: any) => {
                            return (
                                <code
                                    className={`${className} ${inline ? 'bg-white/10 rounded px-1 py-0.5 text-pink-300' : 'block bg-black/50 p-4 rounded-lg my-4 text-xs font-mono border border-white/10 overflow-x-auto'}`}
                                    {...props}
                                >
                                    {children}
                                </code>
                            )
                        }
                    }}
                >
                    {answer}
                </ReactMarkdown>
            </div>
        </div>
    )
}
